<template>
    <div class="modal fade" id="edit_alert" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$lang('Edytuj alert')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <div class="form-group">
                            <label for="type">{{$lang('Typ:')}}</label>
                            <select id="type" name="type" class="form-control" v-model="type">
                                <option value="success">{{$lang('Sukces')}}</option>
                                <option value="info">{{$lang('Informacja')}}</option>
                                <option value="danger">{{$lang('Zagrożenie')}}</option>
                                <option value="warning">{{$lang('Ostrzeżenie')}}</option>
                            </select>

                            <label for="header">{{$lang('Nagłówek:')}}</label>
                            <input type="text" id="header" name="header" class="form-control" v-model="header"/>

                            <label for="content">{{$lang('Treść:')}}</label>
                            <textarea id="content" name="content" class="form-control" v-model="content">
                            </textarea>
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="close">
                        {{$lang('Zamknij')}}
                    </button>
                    <button @click="create" type="button" class="btn btn-primary" :disabled="valid">
                        {{$lang('Zapisz')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "edit-alert-modal",
        props: {
            url: String,
            alert: Object
        },
        data() {
            return {
                id: (this.alert != null ? this.alert.id : ''),
                type: (this.alert != null ? this.alert.type : ''),
                header: (this.alert != null ? this.alert.header : ''),
                content: (this.alert != null ? this.alert.content : '')
            }
        },
        methods: {
            create: function () {
                axios.post(this.url, {
                    id: this.id,
                    type: this.type,
                    header: this.header,
                    content: this.content
                })
                    .then(function () {
                        location.reload();
                        $("#close").click()
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        computed: {
            valid() {
                return !(this.type !== '' && this.content !== '' && this.header !== '');
            }
        },
        watch: {
            alert: {
                deep: true,
                handler() {
                    if (this.alert !== null) {
                        this.id = this.alert.id;
                        this.type = this.alert.type;
                        this.header = this.alert.header;
                        this.content = this.alert.content;
                    }
                }
            }
        }
    }
</script>
